import { computed, DestroyRef, Injectable, signal } from '@angular/core'
import { EMPTY, switchMap } from 'rxjs'
import { injectLogger } from '@/services/logger.service'
import { SocketSubscriptionsService } from '@ibsoftware/ng-web-socket'
import { PlayerWalletDto } from '@/api/player-api/api-models'
import { STORAGE_KEYS, StorageService } from './storage.service'
import { PlayerSessionService } from './player-session.service'

@Injectable({ providedIn: 'root' })
export class WalletService {
	private readonly logger = injectLogger('WalletService')
	private readonly wallet = signal<PlayerWalletDto | null>(null)
	public readonly username = computed(() => this.wallet()?.username ?? '')
	public readonly balance = computed(() => this.wallet()?.balance ?? 0)
	public readonly bonusBalance = computed(() => this.wallet()?.bonusBalance ?? 0)
	private readonly _showBalance = signal<boolean>(StorageService.get(STORAGE_KEYS.showBalance) ?? true)

	public get showBalance() { return this._showBalance() }

	constructor(
		private readonly playerSessionService: PlayerSessionService,
		private readonly socketSubscriptionsService: SocketSubscriptionsService,
		private readonly destroyRef: DestroyRef
	) {
		this.subscribeToWallet()
	}

	subscribeToWallet() {
		this.playerSessionService.sessionOpen$
			.pipe(
				switchMap((sessionState) => {
					if (!sessionState.sessionData.authenticated) {
						this.wallet.set(null)
						return EMPTY
					}

					return this.socketSubscriptionsService
						.subscribeToChannel<PlayerWalletDto>('playerWallet', this.destroyRef)
				})
			)
			.subscribe({
				next: (playerWalletDto) => {
					this.wallet.set(playerWalletDto)
					this.logger.debug('Wallet:', playerWalletDto)
				},
				error: (err) => {
					this.logger.error('subscription error:', err)
				}
			})
	}

	toggleBalanceVisibility() {
		this._showBalance.update((showBalance) => !showBalance)
		StorageService.set(STORAGE_KEYS.showBalance, this.showBalance)
	}
}
